__turbopack_context__.v({
  "Backdrop": "index-module__W6dw9W__Backdrop",
  "Body": "index-module__W6dw9W__Body",
  "Button": "index-module__W6dw9W__Button",
  "Close": "index-module__W6dw9W__Close",
  "Description": "index-module__W6dw9W__Description",
  "FooterLink": "index-module__W6dw9W__FooterLink",
  "FooterNote": "index-module__W6dw9W__FooterNote",
  "Popup": "index-module__W6dw9W__Popup",
  "PopupHeader": "index-module__W6dw9W__PopupHeader",
  "ScrollContent": "index-module__W6dw9W__ScrollContent",
  "ScrollViewport": "index-module__W6dw9W__ScrollViewport",
  "Scrollbar": "index-module__W6dw9W__Scrollbar",
  "ScrollbarThumb": "index-module__W6dw9W__ScrollbarThumb",
  "Section": "index-module__W6dw9W__Section",
  "SectionBody": "index-module__W6dw9W__SectionBody",
  "SectionTitle": "index-module__W6dw9W__SectionTitle",
  "Title": "index-module__W6dw9W__Title",
  "Viewport": "index-module__W6dw9W__Viewport",
});
